import React from 'react';

const MyThoughts: React.FC = () => {
    return (
        <div className="site-page-content">
            <h1>My Thoughts</h1>
            <h3>Daily Musings & Reflections</h3>
            <br />
            <div className="text-block">
                <p>
                    This is where I share my random thoughts, ideas, and daily experiences. 
                    Consider it my digital thinking space.
                </p>
                <br />
                <h3>Latest Thought</h3>
                <p>
                    School is a place where I learn not just academics, but also life skills.
                </p>
                <br />
                <h3>Future Plans</h3>
                <p>
                    - Exploring more advanced programming concepts<br />
                    - Working on bigger projects<br />
                    - Learning about emerging technologies<br />
                    - Planning for university
                </p>
            </div>
        </div>
    );
};

export default MyThoughts;
